export function Init() {
    const statusContainer = $('#processaction-status');
    const url = window.ETDR_RD.appConfig["UrlAction.ProcessActionStatus"];

    statusContainer.load(url, { processActionId: statusContainer.data('processaction-id') },);
}
